module.exports = __webpack_public_path__ + "img/microsoft.1331543d.png";